import React from 'react'
import styled from 'styled-components'
import Clipboard from 'react-clipboard.js'
import { useSpring, animated } from 'react-spring'
import { trackButtonInteraction } from 'api/tracking'
import { Box, Icon, Link, Flex, Text, Heading } from 'components'
import ShareButton from './ShareButton'
import links from './links'

export const ClipboardLink = styled(Link)`
  display: inline-flex;
  margin: 12px 12px 0 12px;
`

const getSiteDescription = () => {
  const metaDataObj = document.getElementsByTagName('meta')
  let description = 'O.school Orgasm Order Form'
  Object.values(metaDataObj).forEach((meta) => {
    if (meta.name === 'description') {
      description = meta.content
    }
  })
  return description
}

export const ShareBox = () => {
  const shareUrl = window ? window.location.href : 'https://www.o.school'
  const title = document ? document.title : 'O.school Orgasm Order Form'
  const description = getSiteDescription()
  const [copied, setCopied] = React.useState(false)
  const props = useSpring({ opacity: copied ? 1 : 0 })

  React.useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false)
      }, 3000)
    }
  }, [copied])

  return (
    <Flex
      margin={2}
      flexDirection='column'
      textAlign='center'
      alignItems='center'
    >
      <Heading as='h2' fontWeight='bold' padding='0px 60px'>
        Invite someone to take the quiz!
      </Heading>
      <Text fontWeight='bold' marginTop={2}>
        Invite with:
      </Text>
      <Flex>
        <Box>
          <ShareButton
            link={links.facebook(shareUrl, description)}
            name='Facebook'
            icon={<Icon name='fb' size='38px' viewBox='45' />}
            onClick={() =>
              trackButtonInteraction('Share to Facebook Button', 'Click')
            }
          />
          <ShareButton
            link={links.twitter(shareUrl, description)}
            name='Twiiter'
            icon={<Icon name='twitter' size='38px' viewBox='45' />}
            onClick={() =>
              trackButtonInteraction('Share to Twitter Button', 'Click')
            }
          />
          <ShareButton
            link={links.mail(shareUrl, title, description)}
            name='Email'
            icon={<Icon name='email' size='38px' viewBox='45' />}
            onClick={() =>
              trackButtonInteraction('Share via Email Button', 'Click')
            }
          />
          <Flex flexDirection='column' display='inline-flex'>
            <Clipboard
              component={ClipboardLink}
              data-clipboard-text={shareUrl}
              onClick={() => {
                trackButtonInteraction('Copy Link Button', 'Click')
                setCopied(true)
              }}
            >
              <Icon name='link' size='38px' viewBox='45' />
            </Clipboard>
            <animated.div style={props}>
              <Text color='green'>Copied!</Text>
            </animated.div>
          </Flex>
        </Box>
      </Flex>
    </Flex>
  )
}
